import { EmbeddedIconButton } from '#PRIVATE_EmbeddedIconButton';
import { ChevronDown } from '#UNSAFE_RedwoodIcons/ChevronDown';
import { ChevronRight } from '#UNSAFE_RedwoodIcons/ChevronRight';
import { ToggleDetail } from '#UNSAFE_Collection';
import { TestIdProps } from '#hooks/UNSAFE_useTestId';
import { classNames } from '#utils/UNSAFE_classNames';

export const ITEM_SELECTOR = 'oj-collection-expander';

/**
 * Props for the Expander component
 */
type Props<K> = TestIdProps & {
  /**
   * The key of the item
   */
  itemKey: K;
  /**
   * A boolean to indicate whether the expander is expander or collapsed
   */
  expanded: boolean;
  /**
   * Callback function to invoke when the user expands or collapses the expander.
   */
  onToggle: (detail: ToggleDetail<K>) => void;
};

/**
 * The Expander component renders expand and collapse icons in collections.
 */
export function Expander<K>({ itemKey, expanded, onToggle }: Props<K>) {
  const classes = classNames([ITEM_SELECTOR]);

  const actionHandler = () => {
    onToggle({ value: itemKey });
  };

  return (
    <span class={classes}>
      <EmbeddedIconButton
        aria-label={expanded ? 'collapsible' : 'expandable'}
        onAction={actionHandler}>
        {expanded ? <ChevronDown size="6x" /> : <ChevronRight size="6x" />}
      </EmbeddedIconButton>
    </span>
  );
}

export const isExpander = (elem: HTMLElement) => {
  if (elem.parentElement && elem.parentElement.classList.contains(ITEM_SELECTOR)) {
    return true;
  }
  return false;
};
